/**************************************************************************************************/
/*   File: /src/app/shared/models/file.model.ts                                                   */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday February 13th 2019                                                   */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The file model
 */
export class FileModel {
  /**
   * The raw data
   */
  rawData?: Blob;
  
  /**
   *  The constructor
   *
   * @param id The id
   * @param buffer The file to upload
   * @param isUploading The is uploading flag
   * @param isUploaded The is uploaded flag
   */
  /* istanbul ignore next */
  constructor(public id: string, public buffer: File, public isUploading: boolean = false, public isUploaded: boolean = false) {
  }
}
